import MuiOutlinedInput from './MuiOutlinedInput';
import MuiPaper from './MuiPaper';
/**
 * These components override in BranchTheme
 * the default styles of their MUI counterparts.
 *
 * You can read more about global styles overriding here:
 * https://mui.com/material-ui/customization/theme-components/
 */
export const Components = {
    MuiOutlinedInput,
    MuiPaper,
};
//# sourceMappingURL=index.js.map